// import { TransactionType } from "@gtpl/shared-models/common-models";
import { ApiProperty } from "@nestjs/swagger";
import { IsOptional } from "class-validator";

export class ForkliftJobDto {
    @ApiProperty()
    unitId: number;
    @ApiProperty()
    transactionType?:string;
    @ApiProperty()
    forkliftJobId?:number;
}